import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M21 8c-4 0 -7 2 -7 5a3 3 0 0 0 6 0c0 -3 -2.5 -5 -8 -5s-8 2 -8 5a3 3 0 0 0 6 0c0 -3 -3 -5 -7 -5","key":"svg-0"}]]

/**
 * IconCurlyLoop
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY3VybHktbG9vcCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMjEgOGMtNCAwIC03IDIgLTcgNWEzIDMgMCAwIDAgNiAwYzAgLTMgLTIuNSAtNSAtOCAtNXMtOCAyIC04IDVhMyAzIDAgMCAwIDYgMGMwIC0zIC0zIC01IC03IC01IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/curly-loop
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCurlyLoop = createReactComponent('outline', 'curly-loop', 'CurlyLoop', __iconNode);

export default IconCurlyLoop;